'use client';

import React from 'react';
import { useCategory } from './hooks';
import EventsByCategory from '../eventsByCategory/eventsByCategory.component';

interface CategoryEventCarouselProps {
  dataEndPoint: string;
  heading: string;
  subHeading: string;
  className?: React.ComponentProps<'div'>['className'];
  colorScheme?: 'dark' | 'light';
  buttonRedirect?: string;
}

export default function CategoryEventCarousel({
  dataEndPoint,
  heading,
  subHeading,
  className = '',
  colorScheme = 'light',
  buttonRedirect= '',
}: CategoryEventCarouselProps): React.ReactNode {
  const { data, loading, refreshing, hasMore, loadMore } = useCategory(dataEndPoint);

  return (
      <EventsByCategory
        colorScheme={colorScheme}
        heading={heading}
        subHeading={subHeading}
        className={className}
        buttonRedirect={buttonRedirect}
        data={!loading ? data : null}
        onEndReached={loadMore}
        hasMore={hasMore}
        loadingMore={refreshing}
      />

  );
}
